import React from 'react';
import { Form, Pane } from '@leverege/ui-elements';
import { GeoPointEditor as GeoPtEditor } from '@leverege/ui-geo-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function GeoPointEditor(props) {
  const {
    attr
  } = props;
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:colS",
    children: [/*#__PURE__*/_jsx(Form.Element, {
      element: GeoPtEditor,
      title: attr.displayName,
      name: attr?.blueprint?.updatePath,
      showMenu: false
    }), /*#__PURE__*/_jsx(Form.Error, {
      variant: "inputCaptionSmallError",
      name: attr?.blueprint?.updatePath
    })]
  });
}
const type = 'geoPoint';
export default {
  editor: GeoPointEditor,
  type
};